import { ERoomsCount, ILayoutRoomCount } from '../../types/newbuilding/layouts';

export function getAvailableRoomsCount(
  currentRoomsCount: ERoomsCount | undefined,
  rooms: ILayoutRoomCount[],
): ERoomsCount | undefined {
  const currentOption = rooms.find(room => room.roomValue === currentRoomsCount);
  if (currentOption?.isAvailable) {
    return currentRoomsCount;
  }

  const newOption = rooms.find(room => room.isAvailable);

  return newOption?.roomValue;
}
